import { render, staticRenderFns } from "./FCheckbox.vue?vue&type=template&id=1b6fc02a&"
import script from "./FCheckbox.vue?vue&type=script&lang=js&"
export * from "./FCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports